import React, { useEffect } from "react";
import { checkAuthAndRedirect } from "../../../utils/auth";
import CreateTestForm from "./CreateTestModal";
import TestPageShell from "./TestPageShell";

const TestCreate: React.FC = () => {
  useEffect(() => {
    checkAuthAndRedirect();
  }, []);

  return (
    <TestPageShell showCardSearch={false}>
      <div
        className="overflow-auto px-4 py-3"
        style={{ height: "calc(100vh - 150px)" }}
      >
        <CreateTestForm />
      </div>
    </TestPageShell>
  );
};

export default TestCreate;
